import { createContext, useEffect, useState } from 'react';
import { IChildrenProps } from '../Interfaces/IChildrenProps';
import { useAuth } from "oidc-react";
import useModal from '../Hooks/useModal';
import ModalTimeout from '../Components/Shared/ModalTimeout';
import { GetTimeoutSession } from '../Utils/StorageSessions';

interface ITimeoutProps {
    updateTimeout: () => void,
    minutes: number,
    seconds: number
}

export const TimeoutContext = createContext({} as ITimeoutProps);

const TimeoutContextProvider = ({ children }: IChildrenProps) => {
    const auth = useAuth();
    let userData = useAuth()?.userData;

    const { showModal, toggleShowModal } = useModal();
    const [ minutes, setMinutes ] = useState<number>(20);
    const [ seconds, setSeconds ] = useState<number>(0);

    const updateTimeout = () => {
        setMinutes(20);
        setSeconds(0);
    }

    useEffect(() => {
        let myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
            if (minutes === 0 && seconds > 58) {
                toggleShowModal();
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    auth.signOut();
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            }
        }, 1000);

        return () => {
            clearInterval(myInterval);
        };
    });

    useEffect(() => {
        function checkTimeout () {
            const timeoutSession = GetTimeoutSession();

            if (timeoutSession !== "") {
                updateTimeout();
            }
        }

        window.addEventListener("storage", checkTimeout);

        return () => {
            window.removeEventListener("storage", checkTimeout);
        };
    }, []);

    return (
        <>
            <ModalTimeout
                minutes={minutes}
                seconds={seconds}
                auth={auth}
                updateTimeout={updateTimeout}
                show={showModal}
                toggleShow={toggleShowModal}
            />
            {auth && userData &&
                <TimeoutContext.Provider value={{ updateTimeout, minutes, seconds }}>
                    {children}
                </TimeoutContext.Provider>
            }
        </>
    )
}

export default TimeoutContextProvider;

